import React from 'react';
import GenericModalWrapper, { IGenericModalWrapper } from './GenericModalWrapper';
import {
    FormGeneratorWithoutModal,
    IFormGeneratorWithoutModalProps,
    IFormGeneratorWithoutModalRef,
} from '../FormGenerator/FormGeneratorWithoutModal';

export interface IFormProps extends IGenericModalWrapper, Omit<IFormGeneratorWithoutModalProps, 'onClose'> {
    // Additional props for close confirmation
    hasUnsavedChanges?: boolean;
    onSaveDraftAndClose?: () => void;
    showCloseConfirmation?: boolean;
}

const Form = React.forwardRef<IFormGeneratorWithoutModalRef, IFormProps>((props, ref) => {
    return (
        <GenericModalWrapper {...props}>
            <FormGeneratorWithoutModal {...props} ref={ref} />
        </GenericModalWrapper>
    );
});

export { Form };
